import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Response } from "src/app/shared/models/Response";
import { Observable } from "rxjs";
import { PagedResponse } from "../shared/models/PagedResponse";
import { Page } from "../shared/models/Page";
import { Proveedor } from "../models/Proveedor/Proveedor";
import { ProveedorFilter } from "../models/Proveedor/ProveedorFilter";
import { ProveedorTagXML } from "../models/Proveedor/ProveedorTagXML";
import { ProveedorReferenceCode } from "../models/Proveedor/ProveedorReferenceCode";
import { TipoReferencium } from "../models/Proveedor/TipoReferencium";
import { XmlTag } from "../models/Proveedor/XmlTag";
import { ProveedorRulesRequest } from "../models/Proveedor/ProveedorRulesRequest";
import { MarcaListaProveedorRequest, ListaProveedorEnum } from "../models/Proveedor/ListaEstadoProveedor";


@Injectable({
	providedIn: "root",
})
export class ProveedorService {
	private REST_API_SERVER = environment.backend_server + "/Proveedor";
	private auth = {};
	constructor(private http: HttpClient) {}

	public getData(): Observable<Response<Proveedor[]>> {
		return this.http.get<Response<Proveedor[]>>(this.REST_API_SERVER + "/list");
	}

	getFromSii(rut: string, emisorId: string): Observable<Response<Proveedor>> {
		return this.http.get<Response<Proveedor>>(this.REST_API_SERVER + "/get-from-sii?rut=" + rut + "&emisorId=" + emisorId);
	}

	public getDataByPage(filtro: ProveedorFilter, page: Page): Observable<PagedResponse<Proveedor>> {
		let formData = new FormData();
		//if(filtro.tipoReferenciaId && filtro.tipoReferenciaId.length>0){
		// formData.append("Referencias",JSON.stringify(filtro.tipoReferenciaId));
		// formData.append("RazonSocial",filtro.razonSocial!= undefined ? filtro.razonSocial : "");
		// formData.append("Rut",filtro.rut!= undefined ? filtro.rut : "");
		// formData.append("Ciudad",filtro.ciudad!= undefined ? filtro.ciudad : "");
		// formData.append("Comuna",filtro.comuna!= undefined ? filtro.comuna : "");
		// formData.append("EmisorId",filtro.emisorId!= undefined? filtro.emisorId:"");
		// formData.append("Giro",filtro.giro!= undefined ? filtro.giro : "");
		// }
		formData.append("referenciasString", JSON.stringify(filtro.tipoReferenciaId));
		let estadoProveedorParams = "";
		if (filtro.listadoEstadoProveedor && filtro.listadoEstadoProveedor.length > 0) {
			estadoProveedorParams = filtro.listadoEstadoProveedor
			.map(e => "&listadoEstadoProveedor=" + e)  // número directamente
			.join("");
		}
		// return this.http.post<PagedResponse<Proveedor>>(
		//   this.REST_API_SERVER +
		//     "/list/filter?pageNumber=" +
		//     page.pageNumber +
		//     "&pageSize=" +
		//     page.pageSize,
		//     formData
		// );
		return this.http.get<PagedResponse<Proveedor>>(
			this.REST_API_SERVER +
				"/list/filter?RazonSocial=" +
				(filtro.razonSocial != undefined ? filtro.razonSocial : "") +
				"&Rut=" +
				(filtro.rut != undefined ? filtro.rut : "") +
				"&Ciudad=" +
				(filtro.ciudad != undefined ? filtro.ciudad : "") +
				"&Comuna=" +
				(filtro.comuna != undefined ? filtro.comuna : "") +
				"&Activo=" +
				filtro.activo +
				"&EmisorId=" +
				(filtro.emisorId != undefined ? filtro.emisorId : "") +
				"&Giro=" +
				(filtro.giro != undefined ? filtro.giro : "") +
				"&referenciasString=" +
				(filtro.tipoReferenciaId != undefined && filtro.tipoReferenciaId.length > 0 ? JSON.stringify(filtro.tipoReferenciaId) : "") +
				estadoProveedorParams +
				"&pageNumber=" +
				page.pageNumber +
				"&pageSize=" +
				page.pageSize
		);
	}

	actualizarProveedor(proveedor: Proveedor): Observable<Response<Proveedor>> {
		proveedor.dirPart = "";
		return this.http.post<Response<Proveedor>>(this.REST_API_SERVER + "/update", proveedor);
	}

	agregarProveedor(proveedor: Proveedor): Observable<Response<Proveedor>> {
		proveedor.dirPart = "";
		return this.http.post<Response<Proveedor>>(this.REST_API_SERVER + "/add", proveedor);
	}

	getXmlTagsListByProveedor(emisorId, proveedorId): Observable<Response<ProveedorTagXML[]>> {
		return this.http.get<Response<ProveedorTagXML[]>>(this.REST_API_SERVER + "/tagListProveedor" + "?emisorId=" + emisorId + "&proveedorId=" + proveedorId);
	}

	getCodesReferenceListByProveedor(emisorId, proveedorId): Observable<Response<ProveedorReferenceCode[]>> {
		return this.http.get<Response<ProveedorReferenceCode[]>>(this.REST_API_SERVER + "/referencesListProveedor" + "?emisorId=" + emisorId + "&proveedorId=" + proveedorId);
	}

	getXmlTagsCompleteList(): Observable<Response<XmlTag>> {
		return this.http.get<Response<XmlTag>>(this.REST_API_SERVER + "/tagList");
	}

	getCodesReferenceCompleteList(): Observable<Response<TipoReferencium[]>> {
		return this.http.get<Response<TipoReferencium[]>>(this.REST_API_SERVER + "/referencesList");
	}

	sendTagRulesRequest(request: ProveedorRulesRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateTagList", request);
	}

	sendReferenceRulesRequest(request: ProveedorRulesRequest): Observable<Response<boolean>> {
		return this.http.post<Response<boolean>>(this.REST_API_SERVER + "/updateReferencesList", request);
	}

	deactivateProvider(providerId: string): Observable<Response<boolean>> {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/deactivate/" + providerId);
	}

	activateProvider(providerId: string): Observable<Response<boolean>> {
		return this.http.get<Response<boolean>>(this.REST_API_SERVER + "/activate/" + providerId);
	}
	actualizarListaProveedores(proveedorIds: string[],TipoProveedor: ListaProveedorEnum) {
		const body: MarcaListaProveedorRequest = {
			proveedorIds,
			TipoProveedor,
		};
		return this.http.post<any>(`${this.REST_API_SERVER}/marcar-tipo-proveedor`, body);
	}

}
